import loadjs from "loadjs"
import { useEffect, useState } from "react"

import { enableKlarnaCheckout } from "helpers/checkout/checkout_options"

const useKlarnaOSM = () => {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    if (
      !sl.api.klarna?.client_id ||
      !sl.api.klarna?.osm_js_src ||
      !enableKlarnaCheckout()
    ) {
      return
    }

    if (!Element.prototype._klarnaShadowPatched) {
      Element.prototype._attachShadow = Element.prototype.attachShadow
      Element.prototype.attachShadow = function () {
        return this._attachShadow({ mode: "open" })
      }
      Element.prototype._klarnaShadowPatched = true
    }

    if (loadjs.isDefined("KlarnaOSM")) {
      loadjs.ready("KlarnaOSM", () => setLoaded(true))
      return
    }

    loadjs(sl.api.klarna.osm_js_src, {
      async: true,
      before: (_, scriptEl) => {
        scriptEl.setAttribute("data-client-id", sl.api.klarna.client_id)
        scriptEl.setAttribute(
          "data-environment",
          sl.config.env === "production" ? "production" : "playground"
        )
      },
      error: () => {
        console.error("Failed to load Klarna OSM SDK")
      },
      success: () => {
        loadjs.done("KlarnaOSM")
        setLoaded(true)
      },
    })
  }, [])

  return loaded
}

export default useKlarnaOSM
